<template>
  <div
    class="card p-5 border-dashed border-color10 col-8 col-lg-4"
    :class="classes"
  >
    <div class="heading d-flex flex-column flex-md-row justify-content-between">
      <div class="text-start px-0">
        <span class="d-block text-color9 mb-1 fw-600 font-size-regular text-capitalize">{{ account.owner_name }}</span>
        <div>
          <span class="font-size-xSmall text-color10 fw-500">{{ account.owner_document | VMask(documentMask) }}</span>
        </div>
      </div>
    </div>
    <div class="separator separator-dashed border-color10 my-5"></div>
    <div class="d-flex flex-column flex-md-row gap-10">
      <p class="d-block">
        <span class="text-color9 mb-1 fw-600">{{ $t('bank') }}</span><br>
        <span class="text-color10 mb-1 fw-500">{{ account.bank.name }}</span>
      </p>
      <p class="d-block">
        <span class="text-color9 mb-1 fw-600">{{ $t('agency') }}</span><br>
        <span class="text-color10 mb-1 fw-500">{{ `${account.agency}${account.agency_digit ? '-' + account.agency_digit : ''}` }}</span>
      </p>
      <p class="d-block">
        <span class="text-color9 mb-1 fw-600">{{ $t('account') }}</span><br>
        <span class="text-color10 mb-1 fw-500">{{ `${account.account}-${account.digit}` }}</span>
      </p>
      <div
        class="d-flex justify-content-center justify-content-lg-end align-items-center mt-3 mt-lg-0"
        v-if="editable"
      >
        <Button
          class="btn-color3 btn-sm"
          v-if="account.is_primary"
        >
          {{ $t('main') }}
        </Button>
        <template
          v-else
        >
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import Button from '@/components/common/Button/Button'
import { mask } from 'vue-the-mask'

export default {
  name: 'BankAccountCard',
  props: ['account', 'size', 'editable'],
  directives: { mask },
  components: {
    Button
  },
  computed: {
    cardSize () {
      return this.size ? this.size : 'regular'
    },
    classes () {
      const data = []
      if (this.cardSize === 'regular') {

      } else if (this.cardSize === 'small') {
        data.push('p-4')
      }

      return data
    },
    documentMask () {
      if (this.account.owner_document_type === 'cpf') return '###.###.###-##'
      return '##.###.###/####-##'
    }
  },
  methods: {
  }
}
</script>
